<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jcdNBk/tc-custom/9780795346712.jpg?1728724770359" alt="This image is the cover for the book Auschwitz and the Allies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Auschwitz and the Allies
      </h1>
      <p class="bookDescription body article font2">
        <b>A thorough analysis of Allied actions after learning about the horrors of Nazi concentration camps—includes survivors’ firsthand accounts. </b><br/>  <br/> Why did they wait so long? Among the myriad questions of what the Allies could have done differently in World War II, understanding why it took them so long to respond to the horrors of the Nazi concentration camps—specifically Auschwitz—remains vital today.<br/>  <br/> In <i>Auschwitz and the Allies</i>, Martin Gilbert presents a comprehensive look into the series of decisions that helped shape this particular course of the war, and the fate of millions of people, through his eminent blend of exhaustive devotion to the facts and accessible, graceful writing.<br/>  <br/> Featuring twenty maps prepared specifically for this history and thirty-four photographs, along with firsthand accounts by escaped Auschwitz prisoners, Gilbert reconstructs the span of time between Allied awareness and definitive action in the face of overwhelming evidence of Nazi atrocities.<br/>  <br/> “An unforgettable contribution to the history of the last war.” —<i>Jewish Chronicle</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin Gilbert
      </h2>
      
      <p class="authorDescription body article">Sir Martin Gilbert was born in England in 1936. He was a graduate of Oxford University, from which he held a Doctorate of Letters, and was an Honorary Fellow of Merton College, Oxford. In 1962 he began work as one of Randolph Churchill&rsquo;s research assistants, and in 1968, after Randolph Churchill&rsquo;s death, he became the official biographer of Winston Churchill. He published six volumes of the Churchill biography, and edited twelve volumes of Churchill documents. During forty-eight years of research and writing, Gilbert published eighty books, including <I>The First World War, The Second World War, </I>and a three-volume <I>History of the Twentieth Century. </I>He also wrote, as part of his series of ten historical atlases, <I>Atlas of the First World War, </I>and, most recently, <I>Atlas of the Second World War.</I> Sir Martin&rsquo;s film and television work included a documentary series on the life of Winston Churchill. His other published works include <I>Churchill: A Photographic Portrait, In Search of Churchill, Churchill and America, </I>and the single volume <I>Churchill, A Life.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bc85dec4